// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__CqXX9","inputWrap":"CustomTip_inputWrap__1YPEP"};